export default __webpack_public_path__ + "static/media/761.25f22d2c.gif";